// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Inn8S__logo {
  position: relative;
  z-index: 5;
  font-family: var(--logo-font);
  font-weight: 400;
  font-size: 1.5em;
  color: var(--color-grey-5);
  /* background-color: white; */
  padding: 0.5em;
  border-radius: 10px;
  margin-top: -0.15em;
}

.Inn8S__logo > a {
    display: contents;
    color: inherit;
  }

.Inn8S__logo > a:active {
      color: inherit;
    }

.Inn8S__logo {

  /* background-image: linear-gradient(45deg, white, #3c6382);
  background-size: 100%;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  -moz-text-fill-color: transparent; */

  .QCaBH__logoImgWrapper {
    display: flex;
    align-items: center;
  }
}

.Inn8S__logo .ESX6j__img {
    color: var(--color-purple-1);
    --fa-secondary-color: var(--color-blue-1);
    --fa-secondary-opacity: 1;
    margin-top: 0.2em;
    margin-right: 0.3em;
  }

@media screen and (min-width: 768px) {

  .Inn8S__logo {
    font-size: 2em;
}
  }

.Inn8S__logo small {
    display: block;
    position: absolute;
    right: 3.4em;
    bottom: 1.1em;
    font-size: 0.3em;
  }
`, "",{"version":3,"sources":["webpack://./src/components/Logo/Logo.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AAwCrB;;AAtCE;IACE,iBAAiB;IACjB,cAAc;EAIhB;;AAHE;MACE,cAAc;IAChB;;AAjBJ;;EAoBE;;;;sCAIoC;;EAEpC;IACE,aAAa;IACb,mBAAmB;EACrB;AAqBF;;AAnBE;IACE,4BAA4B;IAC5B,yCAAyC;IACzC,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;EACrB;;AAEA;;EAvCF;IAwCI,cAAc;AAUlB;EATE;;AAEA;IACE,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB","sourcesContent":[".logo {\n  position: relative;\n  z-index: 5;\n  font-family: var(--logo-font);\n  font-weight: 400;\n  font-size: 1.5em;\n  color: var(--color-grey-5);\n  /* background-color: white; */\n  padding: 0.5em;\n  border-radius: 10px;\n  margin-top: -0.15em;\n\n  & > a {\n    display: contents;\n    color: inherit;\n    &:active {\n      color: inherit;\n    }\n  }\n\n  /* background-image: linear-gradient(45deg, white, #3c6382);\n  background-size: 100%;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  -moz-text-fill-color: transparent; */\n\n  .logoImgWrapper {\n    display: flex;\n    align-items: center;\n  }\n\n  & .img {\n    color: var(--color-purple-1);\n    --fa-secondary-color: var(--color-blue-1);\n    --fa-secondary-opacity: 1;\n    margin-top: 0.2em;\n    margin-right: 0.3em;\n  }\n\n  @media (--screen-md) {\n    font-size: 2em;\n  }\n\n  & small {\n    display: block;\n    position: absolute;\n    right: 3.4em;\n    bottom: 1.1em;\n    font-size: 0.3em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `Inn8S__logo`,
	"logoImgWrapper": `QCaBH__logoImgWrapper`,
	"img": `ESX6j__img`
};
export default ___CSS_LOADER_EXPORT___;
